import { init, reactRouterV6BrowserTracingIntegration, replayIntegration, setUser } from "@sentry/react";
import { env } from "env";
import { useEffect } from "react";
import { createRoutesFromChildren, matchRoutes, useLocation, useNavigationType } from "react-router-dom";
import { combineLatest } from "rxjs";
import { getUserService } from "./user.service";
import { getClientService } from "./client.service";
import { getFFService } from "./ff.service";

class SentryService {
  constructor() {
    combineLatest([getUserService().user$, getClientService().client$, getFFService().ffs$]).subscribe(
      ([user, client, ffs]) => {
        setUser({
          id: user?.id,
          clientId: client?.orgId ?? client?.id,
          ffs: ffs
            ?.map((ff) => ff.ff)
            ?.join(", ")
            .toString(),
        });
      },
    );
  }

  public init = () => {
    if (window.isUnderTest) {
      return;
    }
    init({
      beforeSend: (e) => {
        if (e.exception?.values?.find((a) => a.type === "CloseEvent")) {
          return null;
        }
        return e;
      },
      environment: env?.VITE_MODE || env?.NODE_ENV || "production",
      release: `frontend@${env?.VITE_APP_VERSION}`,
      dsn: "https://900fee6b6742a00e8b5097d16ab96888@o4506079834341376.ingest.sentry.io/4506271548964864",
      integrations: [
        reactRouterV6BrowserTracingIntegration({
          // See docs for support of different versions of variation of react router
          // https://docs.sentry.io/platforms/javascript/guides/react/configuration/integrations/react-router/
          useEffect,
          useLocation,
          useNavigationType,
          createRoutesFromChildren,
          matchRoutes,
        }),
        replayIntegration(),
      ],

      // Set tracesSampleRate to 1.0 to capture 100%
      // of transactions for performance monitoring
      tracesSampleRate: 1.0,
      attachStacktrace: true,
      // Set `tracePropagationTargets`   to control for which URLs distributed tracing should be enabled
      // tracePropagationTargets: ["localhost", /^https:\/\/yourserver\.io\/api/],

      // Capture Replay for 10% of all sessions,
      // plus for 100% of sessions with an error
      replaysSessionSampleRate: 0.1,
      replaysOnErrorSampleRate: 1.0,
      ignoreErrors: [
        "TypeError: Failed to fetch",
        "TypeError: NetworkError when attempting to fetch resource.",
      ],
    });
  };
}

let sentryService: SentryService | null = null;

export const getSentryService = () => {
  if (!sentryService) {
    sentryService = new SentryService();
  }
  return sentryService;
};
